import { endpoints } from "../helper/endpoints";
import jwtInterceptor from "../helper/jtwInterceptor";
import { Broker } from "../shared/types/quotes";

/**
 * Function to retrieve broker details by broker ID.
 * @param {any} brokerId - The ID of the broker for which details are to be fetched.
 * @returns {Promise} A Promise that resolves with the broker details if successful.
 */
export const getBrokerDetails = async (brokerId: any) : Promise<Broker> => {
  // Use 'jwtInterceptor' to make an authenticated API request.
  const brokerDataResponse = await jwtInterceptor({
    method: "post",
    url: endpoints.GET_BROKER_DETAILS_BY_ID,
    // url: "https://u090h4woii.execute-api.ap-southeast-2.amazonaws.com/delta-microservices/microservices-broker-by-id",
    data: JSON.stringify(brokerId),  // Send brokerId as the request data.
    headers: {
      "Content-Type": "application/json",
    },
  });
  // Extract and return the details of the first broker in the response.
  return brokerDataResponse.data.result[0];
}